import { render, staticRenderFns } from "./services.vue?vue&type=template&id=8e237ab2&scoped=true"
import script from "./services.vue?vue&type=script&lang=js"
export * from "./services.vue?vue&type=script&lang=js"
import style0 from "./services.vue?vue&type=style&index=0&id=8e237ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e237ab2",
  null
  
)

export default component.exports